<template>
  <form data-name="jump-search"
    class="basis-45"
    @submit="searchUuidFields">
    <div v-if="isLoading"
      class="spinner-grow"
      role="status">
      <span class="sr-only"
        role="contentinfo">Loading...</span>
    </div>
    <template v-else>
      <label :for="inputUuid">Jump to a service or company</label>
      <p class="small">
        ID should be 8 characters of alpha or numeric characters. E.g. 7ab1028d
      </p>
      <input :id="inputUuid"
        v-model="inputUuidSearch"
        class="form-control"
        type="text"
        pattern="^[A-z0-9]{8}$"
        title="ID should be 8 characters of alpha or numeric characters">
      <div v-if="errorMessage"
        class="alert alert-info"
        role="alert">
        {{ errorMessage }}
      </div>
      <button type="submit"
        class="btn btn-primary btn-sm"
        @click.prevent="searchUuidFields">
        Jump
      </button>

      <p v-if="showTip"
        class="small"
        data-name="tip">
        Tip: Press 't' on any page and enter a service or company identifier (uuid) to instantly view the entity's
        details.
      </p>
    </template>
  </form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SearchResources',

  props: {
    showTip: {
      type: Boolean,
      default: true,
      required: false,
    },
  },

  data() {
    return {
      inputUuidSearch: '',
      errorMessage: null,
      isLoading: false,
      inputUuid: `input-${Math.random()
        .toString()
        .substr(-3)}`,
    }
  },

  methods: {
    ...mapActions('company', ['findCompanyService']),
    async searchUuidFields() {
      this.errorMessage = null
      try {
        this.isLoading = true
        const res = await this.findCompanyService(this.inputUuidSearch)
        this.notifySuccess(res)
      } catch (error) {
        this.notifyError()
      }
      this.isLoading = false
    },
    notifySuccess(res) {
      this.$emit('search-jump-found', true)
      const [first] = res
      this.$router.push(first?.link)
    },
    notifyError() {
      this.errorMessage = `Service with ID ${this.inputUuidSearch} not found.`
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  label {
    font-weight: bold;
  }
  input {
    margin: 1rem 0;
  }
  button {
    margin: 0 1rem 1rem 0;
  }
}
</style>
